import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash';
import { observable, autorun, action, toJS } from 'mobx';
import { observer } from 'mobx-react'

import {DictionaryTrans,autobind} from './DictionaryTrans';
import reactMixin  from 'react-mixin';
import ls from 'local-storage';

@observer
@reactMixin.decorate(DictionaryTrans)
@reactMixin.decorate(autobind(Object.keys(DictionaryTrans)))
export default class Pictures extends Component {


  @observable currentLang = '';

  @observable allowedLangs = {};

  constructor(props) {

    super(props);

    this.trans = this.props.dictionaryStorage.getCurrentLangDict;

    this.allowedLangs = this.props.dictionaryStorage.dictionaryLangsCode;

    let scope = this;
    this.currentLang = this.props.startLang;

  }

  componentDidMount(){
    this.currentLang = ls.get('lang');
  }

  changeLang = (lang) =>
  {
    this.currentLang = lang;
    this.props.dictionaryStorage.switchLang(lang);
    ls.set('lang',lang);
  }


  render() {

    const t = this.t;

    const langs = toJS(this.allowedLangs);


    return (
      <div className={"LangSwitcher " + ( (Object.keys(langs).length > 1) ? ' ' : ' LangSwitcherHide ') + ( this.props.className ? this.props.className : 'LangSwitcherDefault') } >
        {
          _.map(langs, (lang, key) => {
            return(
              <span className={ this.currentLang == lang ? 'active' : ''} onClick={ ()=> { this.changeLang(lang) } } key={key}>{lang}</span>
            )
          })
        }

      </div>
    );


  }
}






